import e from"./Panel.vue_vue&type=script&lang.js";import{render as t}from"./Panel.vue_vue&type=template&id=766abb5d&lang.js";e.render=t;export default e;
//# sourceMappingURL=Panel.vue.js.map
